import { css } from '@emotion/react';

import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.create-update-submission': {
    padding: '16px',
    flexDirection: 'column',
    [mediaquery.md]: {
      height: '100%',
    },
  },
  '.create-update-submission': {
    '&__heading': {
      marginTop: theme.space[4],
    },
    '&__wrapper': {
      padding: `0 ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
      marginBottom: theme.space[6],
      [mediaquery.md]: {
        padding: `0 ${theme.space[5]} ${theme.space[5]} ${theme.space[5]}`,
        marginBottom: 0,
      },
    },
    '&__heading-submission': {
      display: 'none',
      [mediaquery.md]: {
        display: 'block',
      },
    },
  },
  '.split-panel-scroll': {
    padding: 0,
    flex: 1,
    overflow: 'auto',

    '&__grid': {
      gridTemplateColumns: '[left] 0 [right] 1fr [end]',
      [mediaquery.md]: {
        gridTemplateColumns: '[left] minmax(300px,1fr) [right] 2fr [end];',
      },
    },
    '&__left-header': {
      display: 'none',
      [mediaquery.md]: {
        display: 'block',
      },
    },
    '&__left-panel': {
      display: 'none',
      [mediaquery.md]: {
        display: 'block',
      },
    },
  },
});
